// @flow
export const BASE_URL = (): string => {return process.env.REACT_APP_DYNAMIC_PATH || ''; };
export const LOCALSTORE = (): boolean => (false);
